var _ = require('lodash');

(function Module() {
	'use strict';

	mySynch.directive('checkonline', [
		'$rootScope',
		'$interval',
		'$timeout',
		'F360Constant',
		'ApiFactory',
		'AuditService',
		'$location',
		'clientLoggerService',
		function checkonline($rootScope,$interval, $timeout, constant, api, auditService, $location, log) {
			return {
				restrict : "E",
				link: function ($scope) {
					$scope.checkF360Online = true;
					$scope.flashDisplayOnline = false;
					$scope.onlineStatus = $rootScope.onLine;
					var deregOnlineCheckWatch = undefined;
					
					
					deregOnlineCheckWatch =	$scope.$on('online:change',function(event,onLineChange){
						  
						
						   var onLineValue = _.get(onLineChange,'value');
						   var isOnlineOldValue =  angular.copy($scope.onlineStatus);
						   $scope.onlineStatus = onLineValue;
						 
					
						 if(isOnlineOldValue === false && onLineValue === true){
							 $scope.flashDisplayOnline = true;
							 $timeout( function() {
								$scope.flashDisplayOnline = false;
			 				}, 2000 );
						
						}else{
							$scope.flashDisplayOnline = false;
						}

						if(!$scope.onlineStatus){
							$scope.$apply();
						}
						
					});


					window.onfocus = function() {  
						
					};
		
					window.onblur = function() {
					
					};

					$scope.$on("$destroy", function() {
						window.onblur = undefined;
						window.onfocus = undefined;
					
						deregOnlineCheckWatch();
					});
				},
				template:
					'<div class="row">' +
						'<div class="col-xs-12 mt--2" ng-show="onlineStatus && flashDisplayOnline">' +
							'<div class="float-right mt-2">Online</div>' +
							'<div class="image-sync-area text-right tooltip-sync"><img class="img-sync center-block" src="img/online.png" alt="alt"/></div>' +
						'</div>' +
						'<div class="col-xs-12 mt--2" ng-show="!onlineStatus">' +
							'<div class="float-right mt-2">Offline</div>' +
							'<div class="image-sync-area text-right"><img class="img-sync center-block" src="img/offline.png" alt="alt"/></div>' +
						'</div>' +
					'</div>'
			};
		}
	]);
})();
